module.exports = __webpack_public_path__ + "static/img/bg_gd.294b85ce.png";